import { useState, useCallback } from "react";
import { adminApi } from "../repositories/admin";

interface AimsTrackingRecord {
  id: string;
  api_call: string;
  date: string;
  time: string;
  email: string;
  label_name: string;
  is_succeeded: boolean;
  createdAt: string;
}

interface SummaryData {
  totalCalls: number;
  successfulCalls: number;
  failedCalls: number;
  successRate: string;
}

interface PaginationData {
  currentPage: number;
  pageSize: number;
  totalItems: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

interface AimsTrackingResponse {
  success: boolean;
  summary: SummaryData;
  data: AimsTrackingRecord[];
  pagination: PaginationData;
}

export const useAimsTracking = () => {
  const [analytics, setAnalytics] = useState<AimsTrackingResponse | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAnalytics = useCallback(
    async (months: number = 3, page: number = 1, limit: number = 100) => {
      try {
        setLoading(true);
        setError(null);
        const response = await adminApi.getAllAimsTracking({ months, page, limit });
        setAnalytics(response.data);
      } catch (err: any) {
        const errorMessage =
          err?.response?.data?.message ||
          err?.message ||
          "Failed to fetch AIMS analytics";
        setError(errorMessage);
        console.error("Error fetching AIMS analytics:", err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { analytics, loading, error, fetchAnalytics };
};
